"use client";

import { formOptions } from "@tanstack/react-form";
import {
  clearFormData,
  getSavedFormData,
  setFormData,
} from "@/components/tan-stack-form/form-options";
import type { GiftingDetailsFormData } from "./schema";

export const GIFTING_DETAILS = "gifting-details";

export const clearGiftingDetailsDraft = () => clearFormData(GIFTING_DETAILS);

/** Same-tab signal so the cart summary can refresh when quantity changes. */
export const GIFTING_QUANTITY_CHANGED_EVENT = "gifting-quantity-changed";

export function notifyGiftingQuantityChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(GIFTING_QUANTITY_CHANGED_EVENT));
}

export const emptyRecipient = { name: "", email: "" };

export const getRecipientIndexesToReset = (
  currentLength: number,
  nextLength: number,
) => {
  const start = Math.min(currentLength, nextLength);
  const end = Math.max(currentLength, nextLength);

  return Array.from({ length: end - start }, (_, index) => start + index);
};

export const getDefaultValues = (): GiftingDetailsFormData => {
  const saved: GiftingDetailsFormData | undefined =
    getSavedFormData(GIFTING_DETAILS);

  if (saved) return saved;

  const defaults: GiftingDetailsFormData = {
    quantity: 1,
    recipients: [{ ...emptyRecipient }],
    senderName: "",
    senderEmail: "",
    giftSendDate: "",
    giftSendTime: "",
  };
  setFormData(GIFTING_DETAILS, defaults);
  return defaults;
};

export const formOpts = formOptions({
  defaultValues: {
    quantity: 1,
    recipients: [{ ...emptyRecipient }],
    senderName: "",
    senderEmail: "",
    giftSendDate: "",
    giftSendTime: "",
  } satisfies GiftingDetailsFormData,
});
